import * as tslib_1 from "tslib";
import { BaseModel } from '../../_base/crud';
var Role = /** @class */ (function (_super) {
    tslib_1.__extends(Role, _super);
    function Role() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Role.prototype.clear = function () {
        this.role_id = undefined;
        this.role_name_ar = '';
        this.role_name_en = '';
        this.role_name = '';
        this.permissions = [];
    };
    return Role;
}(BaseModel));
export { Role };
